import styled from 'styled-components';
// @ts-expect-error not typed
import HubSpotVideoPlayer from 'ui-addon-video-player/components/HubSpotVideoPlayer';
import { jsx as _jsx } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "HubspotVideoPlayer__Wrapper",
  componentId: "sc-18emj1e-0"
})(["margin-top:10px;margin-bottom:10px;"]);
const HubspotPlayer = ({
  videoId
}) => {
  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsx(HubSpotVideoPlayer, {
      videoId: videoId,
      portal: "53",
      env: "prod"
    })
  });
};
export default HubspotPlayer;